import { useReducer } from 'react';
import { NewCampaignReducer } from './NewCampaignReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  NewCampaignDispatchContext,
  NewCampaignStateContext,
} from './UseNewCampaignContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface INewCampaignProviderProps {
  children: any;
  value?: IValue;
}

export function NewCampaignProvider({
  children,
  value = { initialState: defaultContextValues, reducer: NewCampaignReducer },
}: INewCampaignProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <NewCampaignStateContext.Provider value={state}>
      <NewCampaignDispatchContext.Provider value={dispatch}>{children}</NewCampaignDispatchContext.Provider>
    </NewCampaignStateContext.Provider>
  );
}
